<template>
<!-- LOADING SCREEN -->
<transition name="loader-fade">
  <div v-if="!fontsLoaded" class="loader-overlay">
    <div class="loader-dots">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</transition>
<!-- NAV -->
<nav>
  <div class="logo">
    <img class="logo-icon" src="./assets/logo.png" alt="Wolf Trails Logo">
  </div>
  <ul>
    <li class="nav-desktop-only"><a href="#sobre">Sobre</a></li>
    <li class="nav-desktop-only"><a href="#trilhas">Trilhas</a></li>
    <li class="nav-desktop-only"><a href="#experiencia">Planejamento</a></li>
    <li class="nav-desktop-only"><a href="#depoimentos">Depoimentos</a></li>
    <li><a href="#contato" class="nav-cta">Entrar em Contato</a></li>
  </ul>
</nav>

<!-- HERO -->
<section class="hero">
  <div class="hero-bg"></div>
  <div class="hero-overlay"></div>
  <div class="hero-camo"></div>
  <div class="hero-content">
    <p class="hero-eyebrow"></p>
    <h1 class="hero-title">WOLF<br><span class="accent">TRAILS</span></h1>
    <p class="hero-sub">Desperte o instinto. Deixe a sua pegada.</p>
    <div class="hero-actions">
      <a href="#trilhas" class="btn-primary"><span>Ver Trilhas</span></a>
      <a href="#sobre" class="btn-secondary">Nossa História</a>
    </div>
    <!-- Role: visível só no mobile, dentro do flow para ficar centralizado -->
    <div class="hero-scroll">
      <span class="scroll-label">Role</span>
      <div class="scroll-line"></div>
    </div>
  </div>
</section>

<!-- STATS BAND -->
<div class="stats-band">
  <div class="stat-item">
    <div class="stat-num">12+</div>
    <div class="stat-label">Trilhas Exclusivas</div>
  </div>
  <div class="stat-item">
    <div class="stat-num">200+</div>
    <div class="stat-label">Aventureiros Guiados</div>
  </div>
  <div class="stat-item">
    <div class="stat-num">4.9</div>
    <div class="stat-label">Avaliação nas Trilhas</div>
  </div>
  <div class="stat-item">
    <div class="stat-num">100%</div>
    <div class="stat-label">Segurança Garantida</div>
  </div>
</div>

<!-- ABOUT -->
<section id="sobre">
  <div class="about-grid">
    <div class="about-text reveal">
      <div class="section-tag">Nossa História</div>
      <h2 class="section-title">A FORÇA DA<br><span class="green">ALCATEIA</span></h2>
      <p>Existem lobos que nasceram para desbravar novos caminhos e deixar a sua própria pegada. A Wolf Trails compartilha desse espírito, guiando a nossa alcateia por paisagens deslumbrantes, cachoeiras revigorantes e pura tranquilidade. Aqui, a natureza não é apenas um lugar a se visitar, é uma conexão que transforma.</p>
      <p style="margin-top:1rem">Para quem escuta esse chamado, mesmo sem nunca ter feito uma trilha: você encontrou o seu bando. Em uma alcateia, o ritmo de um é o ritmo de todos. Nós nos levantamos, nos apoiamos e nenhum lobo é deixado para trás. Você não apenas caminha, você se torna parte de nós. Cada percurso é desenhado para despertar o instinto do lobo que existe em todo aventureiro.</p>
      <div style="margin-top:2rem">
        <a href="#trilhas" class="btn-primary"><span>Explorar Trilhas</span></a>
      </div>
    </div>
    <div class="about-visual reveal" style="transition-delay:0.2s">
      <img class="about-img-main"
           src="./assets/imagem-com-bandeira.jpg"
           alt="Wolf Trails com Bandeira">
      <div class="about-badge">
        <div class="badge-num">12+</div>
        <div class="badge-text">Trilhas Mapeadas</div>
      </div>
    </div>
  </div>
</section>

<TrailsSection :section-data="sectionsData.trails" />

<!-- EXPERIENCE -->
<section id="experiencia">
  <div class="experience-grid">
    <div class="reveal">
      <div class="section-tag">Planejamento</div>
      <h2 class="section-title">O QUE VOCÊ<br><span class="green">PRECISA SABER</span></h2>
      <div class="exp-items">
        <div class="exp-item">
          <span class="exp-num">01</span>
          <div class="exp-body">
            <h3>Guias com Conhecimento Local</h3>
            <p>Nossos guias conhecem a região. Estão totalmente equipados e devidamente preparados para garantir uma experiência rica e 100% segura.</p>
          </div>
        </div>
        <div class="exp-item">
          <span class="exp-num">02</span>
          <div class="exp-body">
            <h3>Equipamentos Necessários</h3>
            <p>Recomendamos estar uniformemente vestido com camisa UV, calça e bota. Preferencialmente, tenha em mãos bastão, chapéu, protetor solar e repelente. Demais instruções são comunicadas pelos responsáveis.</p>
          </div>
        </div>
        <div class="exp-item">
          <span class="exp-num">03</span>
          <div class="exp-body">
            <h3>Transporte Privado</h3>
            <p>Em nossas viagens, realizamos transporte próprio, climatizado e seguro. Nossas poltronas são confortáveis e passamos em pontos previamente informados. A ida e volta à trilha é nossa responsabilidade.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="exp-visual reveal" style="transition-delay:0.3s">

      <img class="exp-main-img"
           src="./assets/transporte.jpg"
           alt="Transporte Wolf Trails">
    </div>
  </div>
</section>

<TestimonialsSection :section-data="sectionsData.testimonials" />

<!-- CTA / CONTACT -->
<section id="contato">
  <div class="cta-bg"></div>
  <div class="cta-overlay"></div>
  <div class="cta-content reveal">
    <div class="section-tag" style="justify-content:center">Entre em contato</div>
    <h2 class="cta-title">PRONTO PARA<br><em>DEIXAR SUA PEGADA?</em></h2>
    <p class="cta-sub">Deixe seu contato. A alcateia entra em ação.</p>
    <div class="cta-btn-wrapper">
      <a href="https://wa.me/5575997121808?text=Ol%C3%A1%2C%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20para%20participar%20de%20uma%20trilha" target="_blank" class="cta-whatsapp-btn">
        <i class="fa-brands fa-whatsapp"></i> Chamar no WhatsApp
      </a>
    </div>
    <div class="cta-contacts">
      <div class="cta-contact-item">
        <span class="label">Instagram</span>
        <a href="https://instagram.com/wolftrailswt" target="_blank" class="value contact-link">@wolftrailswt</a>
      </div>
      <div class="cta-contact-item">
        <span class="label">Email</span>
        <a href="mailto:contato@wolftrails.org" class="value contact-link">contato@wolftrails.org</a>
      </div>
      <div class="cta-contact-item">
        <span class="label">Localização</span>
        <span class="value">Serrinha, Bahia</span>
      </div>
    </div>
  </div>
</section>

<!-- FOOTER -->
<footer>
  <div class="footer-logo">WOLF <span>TRAILS</span></div>
  <div class="footer-copy">
    © 2026 Wolf Trails · Todos os direitos reservados<br>
    Feito por <a href="https://micaelmuniz.com" target="_blank" rel="noopener noreferrer">Micael Muniz</a>
  </div>
  <div class="footer-social">
    <a href="https://instagram.com/wolftrailswt" target="_blank" class="social-link tooltip" data-tooltip="@wolftrailswt"><i class="fa-brands fa-instagram"></i></a>
    <a href="https://www.facebook.com/people/Wolf-Trails-Trilhas-Acampamentos/61579445992574/" target="_blank" class="social-link tooltip" data-tooltip="Wolf Trails"><i class="fa-brands fa-facebook-f"></i></a>
    <a href="mailto:contato@wolftrails.org" class="social-link tooltip" data-tooltip="contato@wolftrails.org"><i class="fa-regular fa-envelope"></i></a>
    <a href="https://wa.me/5575997121808?text=Ol%C3%A1%2C%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20para%20participar%20de%20uma%20trilha" target="_blank" class="social-link tooltip" data-tooltip="(75) 99712-1808"><i class="fa-brands fa-whatsapp"></i></a>
  </div>
</footer>
</template>

<script>
import TrailsSection from "./components/TrailsSection.vue";
import TestimonialsSection from "./components/TestimonialsSection.vue";
import sectionsData from "./data/sectionsData";

export default {
  name: "App",
  components: {
    TrailsSection,
    TestimonialsSection
  },
  data() {
    return {
      sectionsData,
      io: null,
      lastPaw: 0,
      handleMouseMove: null,
      handleScroll: null,
      fontsLoaded: false
    };
  },
  mounted() {
    document.fonts.ready.then(() => {
      // small extra delay so the fade feels intentional, not jarring
      setTimeout(() => { this.fontsLoaded = true; }, 300);
    });
    this.setupReveal();
    this.setupPawTrail();
    this.setupNavActiveState();
  },
  beforeUnmount() {
    if (this.io) {
      this.io.disconnect();
      this.io = null;
    }

    if (this.handleMouseMove) {
      document.removeEventListener("mousemove", this.handleMouseMove);
    }

    if (this.handleScroll) {
      window.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    setupReveal() {
      const reveals = document.querySelectorAll(".reveal");
      this.io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("visible");
              this.io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      reveals.forEach((reveal) => this.io.observe(reveal));
    },
    setupPawTrail() {
      this.handleMouseMove = (e) => {
        const now = Date.now();
        if (now - this.lastPaw < 400) return;
        this.lastPaw = now;

        const paw = document.createElement("div");
        paw.className = "paw-trail";
        paw.textContent = "\u{1F43E}";
        paw.style.left = `${e.clientX - 12}px`;
        paw.style.top = `${e.clientY - 12}px`;
        document.body.appendChild(paw);

        setTimeout(() => paw.remove(), 1000);
      };

      document.addEventListener("mousemove", this.handleMouseMove);
    },
    setupNavActiveState() {
      const sections = document.querySelectorAll("section[id], div[id]");
      const navLinks = document.querySelectorAll("nav ul a");

      this.handleScroll = () => {
        let curr = "";
        sections.forEach((section) => {
          if (window.scrollY >= section.offsetTop - 120) {
            curr = section.id;
          }
        });

        navLinks.forEach((link) => {
          link.style.opacity =
            link.getAttribute("href") === `#${curr}` ? "1" : "0.8";
        });
      };

      window.addEventListener("scroll", this.handleScroll);
      this.handleScroll();
    }
  }
};
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Cinzel:wght@400;700;900&family=Barlow+Condensed:ital,wght@0,300;0,400;0,600;1,300&display=swap');

/* =========================================================
   LOADING SCREEN — pure CSS, zero external dependencies
   ========================================================= */
.loader-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: #0a0a08;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loader-dots {
  display: flex;
  gap: 10px;
  align-items: center;
}

.loader-dots span {
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #b5a96e;
  animation: dotPulse 1.2s ease-in-out infinite;
}

.loader-dots span:nth-child(2) { animation-delay: 0.2s; }
.loader-dots span:nth-child(3) { animation-delay: 0.4s; }

@keyframes dotPulse {
  0%, 80%, 100% { transform: scale(0.6); opacity: 0.3; }
  40%            { transform: scale(1);   opacity: 1;   }
}

/* Fade-out transition */
.loader-fade-leave-active {
  transition: opacity 0.5s ease;
}
.loader-fade-leave-to {
  opacity: 0;
}

:root {
    --black: #0a0a08;
    --white: #f0ede6;
    --green: #2d4a1e;
    --green-light: #4a7a30;
    --khaki: #8a7d52;
    --khaki-light: #b5a96e;
    --camo-1: #3d4a2a;
    --camo-2: #5a6e3a;
    --camo-3: #8a7d52;
    --camo-4: #2a3018;
  }

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  html { scroll-behavior: smooth; }

  body {
    background: var(--black);
    color: var(--white);
    font-family: 'Barlow Condensed', sans-serif;
    overflow-x: hidden;
    cursor: crosshair;
  }

  /* CAMO TEXTURE */
  .camo-bg {
    background-image:
      radial-gradient(ellipse 80px 60px at 10% 20%, var(--camo-1) 0%, transparent 100%),
      radial-gradient(ellipse 120px 80px at 80% 10%, var(--camo-2) 0%, transparent 100%),
      radial-gradient(ellipse 60px 90px at 50% 60%, var(--camo-4) 0%, transparent 100%),
      radial-gradient(ellipse 100px 50px at 30% 80%, var(--camo-1) 0%, transparent 100%),
      radial-gradient(ellipse 80px 70px at 70% 70%, var(--camo-2) 0%, transparent 100%);
    background-color: var(--green);
  }

  /* NAVBAR */
  nav {
    position: fixed; top: 0; left: 0; right: 0; z-index: 100;
    padding: 1.2rem 4rem;
    display: flex; align-items: center; justify-content: space-between;
    background: linear-gradient(to bottom, rgba(0,0,0,0.85) 0%, transparent 100%);
    backdrop-filter: blur(2px);
  }

  .logo {
    display: flex; align-items: center; gap: 0.8rem;
  }

  .logo-icon {
    width: 72px; height: 72px;
    object-fit: contain;
    filter: drop-shadow(0 0 8px rgba(181,169,110,0.3));
  }

  .logo-text {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 2rem;
    letter-spacing: 0.15em;
    color: var(--white);
    line-height: 1;
  }

  .logo-text span {
    color: var(--khaki-light);
  }

  nav ul {
    list-style: none;
    display: flex; gap: 2.5rem;
  }

  nav ul a {
    font-family: 'Barlow Condensed', sans-serif;
    font-weight: 600;
    font-size: 0.85rem;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: var(--white);
    text-decoration: none;
    opacity: 0.8;
    transition: opacity 0.2s, color 0.2s;
    position: relative;
  }

  nav ul a::after {
    content: '';
    position: absolute; bottom: -4px; left: 0; right: 0;
    height: 1px;
    background: var(--khaki-light);
    transform: scaleX(0);
    transition: transform 0.3s;
  }

  nav ul a:hover { opacity: 1; color: var(--khaki-light); }
  nav ul a:hover::after { transform: scaleX(1); }

  .nav-cta {
    background: var(--green);
    border: 1px solid var(--khaki);
    color: var(--white) !important;
    padding: 0.5rem 1.4rem;
    opacity: 1 !important;
    transition: background 0.3s !important;
  }
  .nav-cta:hover { background: var(--khaki) !important; }

  /* HERO */
  .hero {
    position: relative;
    height: 100vh; min-height: 700px;
    display: flex; align-items: center; justify-content: center;
    overflow: hidden;
  }

  .hero-bg {
    position: absolute; inset: 0;
    background-image: url('https://www.melhoresdestinos.com.br/wp-content/uploads/2019/10/chapada-diamantina.jpg');
    background-size: cover;
    background-position: center 30%;
    transform: scale(1.05);
    animation: slowZoom 20s ease-in-out infinite alternate;
    filter: brightness(0.45) saturate(0.7);
  }

  @keyframes slowZoom {
    from { transform: scale(1.05); }
    to   { transform: scale(1.12); }
  }

  .hero-overlay {
    position: absolute; inset: 0;
    background: linear-gradient(
      to bottom,
      rgba(0,0,0,0.3) 0%,
      rgba(10,30,5,0.15) 40%,
      rgba(0,0,0,0.7) 100%
    );
  }

  /* Camo pattern overlay */
  .hero-camo {
    position: absolute; inset: 0;
    opacity: 0.06;
    background-image:
      radial-gradient(ellipse 200px 150px at 5% 15%, var(--camo-1) 0%, transparent 100%),
      radial-gradient(ellipse 280px 200px at 90% 5%, var(--camo-2) 0%, transparent 100%),
      radial-gradient(ellipse 150px 250px at 60% 55%, var(--camo-4) 0%, transparent 100%),
      radial-gradient(ellipse 220px 120px at 20% 85%, var(--camo-1) 0%, transparent 100%),
      radial-gradient(ellipse 180px 160px at 75% 80%, var(--camo-2) 0%, transparent 100%);
  }

  .hero-content {
    position: relative; z-index: 2;
    text-align: center;
    padding: 0 2rem;
  }

  .hero-eyebrow {
    font-family: 'Barlow Condensed', sans-serif;
    font-weight: 300;
    font-size: 0.9rem;
    letter-spacing: 0.5em;
    text-transform: uppercase;
    color: var(--khaki-light);
    margin-bottom: 1.5rem;
    animation: fadeUp 1s ease both 0.2s;
  }

  .hero-title {
    font-family: 'Bebas Neue', sans-serif;
    font-size: clamp(5rem, 15vw, 13rem);
    line-height: 0.9;
    letter-spacing: 0.04em;
    color: var(--white);
    animation: fadeUp 1s ease both 0.4s;
    text-shadow: 0 0 80px rgba(0,0,0,0.8);
  }

  .hero-title .accent { color: var(--khaki-light); }

  .hero-sub {
    font-family: 'Cinzel', serif;
    font-size: clamp(0.9rem, 2vw, 1.3rem);
    letter-spacing: 0.25em;
    color: var(--white);
    opacity: 0.75;
    margin-top: 1.5rem;
    animation: fadeUp 1s ease both 0.6s;
  }

  .hero-actions {
    margin-top: 3rem;
    display: flex; gap: 1.2rem; justify-content: center;
    animation: fadeUp 1s ease both 0.8s;
  }

  .btn-primary {
    font-family: 'Barlow Condensed', sans-serif;
    font-weight: 600;
    font-size: 0.85rem;
    letter-spacing: 0.25em;
    text-transform: uppercase;
    text-decoration: none;
    padding: 1rem 2.5rem;
    background: var(--green);
    color: var(--white);
    border: 2px solid var(--green-light);
    transition: all 0.3s;
    position: relative;
    overflow: hidden;
  }

  .btn-primary::before {
    content: '';
    position: absolute; inset: 0;
    background: var(--khaki);
    transform: translateX(-100%);
    transition: transform 0.3s;
    z-index: 0;
  }

  .btn-primary:hover::before { transform: translateX(0); }
  .btn-primary span { position: relative; z-index: 1; }

  .btn-secondary {
    font-family: 'Barlow Condensed', sans-serif;
    font-weight: 600;
    font-size: 0.85rem;
    letter-spacing: 0.25em;
    text-transform: uppercase;
    text-decoration: none;
    padding: 1rem 2.5rem;
    background: transparent;
    color: var(--white);
    border: 2px solid rgba(240,237,230,0.4);
    transition: all 0.3s;
  }

  .btn-secondary:hover {
    border-color: var(--khaki-light);
    color: var(--khaki-light);
  }

  /* hero-scroll: desktop — absolute bottom center */
  .hero-scroll {
    display: none; /* escondido no desktop */
  }

  @media (max-width: 767px) {
    .hero-scroll {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.5rem;
      margin-top: 2.5rem;
      animation: fadeUp 1s ease both 1s;
    }
  }

  .scroll-label {
    font-size: 0.65rem;
    letter-spacing: 0.3em;
    text-transform: uppercase;
    opacity: 0.5;
    margin-right: -0.3em;
  }

  .scroll-line {
    width: 1px; height: 50px;
    background: linear-gradient(to bottom, var(--khaki-light), transparent);
    animation: scrollPulse 2s ease-in-out infinite;
  }

  @keyframes scrollPulse {
    0%, 100% { opacity: 0.3; transform: scaleY(1); }
    50% { opacity: 1; transform: scaleY(1.2); }
  }

  /* WOLF DIVIDER SVG */
  .wolf-divider {
    width: 100%; display: block; margin: -1px 0;
    line-height: 0;
  }

  /* STATS BAND */
  .stats-band {
    background: var(--green);
    padding: 1.5rem 4rem;
    display: flex; justify-content: center; gap: 0;
    border-top: 2px solid var(--khaki);
    border-bottom: 2px solid var(--khaki);
  }

  .stat-item {
    flex: 1; max-width: 220px;
    text-align: center;
    padding: 0.8rem 2rem;
    border-right: 1px solid rgba(138,125,82,0.3);
  }
  .stat-item:last-child { border-right: none; }

  .stat-num {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 3rem;
    color: var(--khaki-light);
    line-height: 1;
  }

  .stat-label {
    font-size: 0.7rem;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    opacity: 0.65;
    margin-top: 0.2rem;
  }

  /* SECTION: ABOUT */
  section { padding: 6rem 4rem; }

  .section-tag {
    font-size: 0.7rem;
    letter-spacing: 0.4em;
    text-transform: uppercase;
    color: var(--khaki-light);
    margin-bottom: 1rem;
    display: flex; align-items: center; gap: 1rem;
  }
  .section-tag::before {
    content: '';
    display: inline-block;
    width: 30px; height: 1px;
    background: var(--khaki-light);
  }

  .section-title {
    font-family: 'Bebas Neue', sans-serif;
    font-size: clamp(3rem, 6vw, 5.5rem);
    letter-spacing: 0.04em;
    line-height: 0.95;
    color: var(--white);
  }

  .section-title .green { color: var(--green-light); }

  /* About layout */
  .about-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 5rem;
    align-items: center;
    max-width: 1300px;
    margin: 0 auto;
  }

  .about-text p {
    font-size: 1.15rem;
    font-weight: 300;
    line-height: 1.8;
    opacity: 0.8;
    margin-top: 2rem;
  }

  .about-visual {
    position: relative;
    height: 500px;
  }

  .about-img-main {
    width: 80%;
    height: 420px;
    object-fit: cover;
    position: absolute;
    right: 0; top: 0;
    filter: saturate(0.85) brightness(0.9);
    border: 2px solid var(--khaki);
  }

  .about-badge {
    position: absolute;
    bottom: 0; left: 0;
    width: 180px; height: 180px;
    background: var(--green);
    border: 2px solid var(--khaki);
    display: flex; flex-direction: column;
    align-items: center; justify-content: center;
    text-align: center;
    padding: 1.5rem;
  }

  .badge-num {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 3.5rem;
    color: var(--khaki-light);
    line-height: 1;
  }

  .badge-text {
    font-size: 0.7rem;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    opacity: 0.7;
    margin-top: 0.3rem;
  }

  /* TRAILS */
  #trilhas {
    background: #0d0d0a;
  }

  .trails-header {
    text-align: center;
    margin-bottom: 4rem;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }

  .trails-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5px;
    max-width: 1300px;
    margin: 0 auto;
    background: var(--khaki);
  }

  .trail-card {
    background: var(--black);
    position: relative;
    overflow: hidden;
    aspect-ratio: 3/4;
    cursor: pointer;
  }

  .trail-card-bg {
    position: absolute; inset: 0;
    background-size: cover;
    background-position: center;
    filter: brightness(0.5) saturate(0.5);
    transition: filter 0.6s, transform 0.6s;
  }

  .trail-card:hover .trail-card-bg {
    filter: none;
    transform: scale(1.08);
  }

  .trail-card-content {
    position: absolute; inset: 0;
    padding: 2rem;
    display: flex; flex-direction: column; justify-content: flex-end;
    background: linear-gradient(to top, rgba(0,0,0,0.9) 0%, transparent 60%);
  }

  .trail-level {
    font-size: 0.65rem;
    letter-spacing: 0.3em;
    text-transform: uppercase;
    padding: 0.3rem 0.8rem;
    border: 1px solid currentColor;
    display: inline-block;
    margin-bottom: 1rem;
    width: fit-content;
  }

  .level-easy      { color: #6abf69; }
  .level-medium    { color: var(--khaki-light); }
  .level-difficult { color: #e69c5e; }
  .level-hard      { color: #e05c5c; }

  .trail-name {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 2.2rem;
    letter-spacing: 0.05em;
    color: var(--white);
    line-height: 1;
  }

  .trail-info {
    margin-top: 0.8rem;
    display: flex; gap: 1.5rem;
    font-size: 0.75rem;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    opacity: 0.6;
  }

  .trail-arrow {
    position: absolute; top: 1.5rem; right: 1.5rem;
    width: 40px; height: 40px;
    border: 1px solid rgba(240,237,230,0.3);
    display: flex; align-items: center; justify-content: center;
    opacity: 0;
    transition: opacity 0.3s, background 0.3s;
    font-size: 1.2rem;
  }

  .trail-card:hover .trail-arrow {
    opacity: 1;
    background: var(--khaki);
    border-color: var(--khaki);
  }

  /* Trail bg colors (fallback) */
  .t1 { background: linear-gradient(135deg, #1a2e10, #3d5e2a); }
  .t2 { background: linear-gradient(135deg, #2a2010, #5a4a20); }
  .t3 { background: linear-gradient(135deg, #10201a, #2a4a3d); }
  .t4 { background: linear-gradient(135deg, #201510, #4a3020); }
  .t5 { background: linear-gradient(135deg, #1a1a10, #3d3d20); }
  .t6 { background: linear-gradient(135deg, #15201a, #304a3d); }

  /* EXPERIENCE */
  #experiencia {
    background: var(--black);
    position: relative;
    overflow: hidden;
  }

  #experiencia::before {
    content: 'WOLF';
    position: absolute;
    font-family: 'Bebas Neue', sans-serif;
    font-size: 35vw;
    color: rgba(255,255,255,0.018);
    bottom: -5vw; right: -3vw;
    line-height: 1;
    pointer-events: none;
    user-select: none;
  }

  .experience-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 4rem;
    max-width: 1300px;
    margin: 0 auto;
    align-items: center;
  }

  .exp-items {
    display: flex; flex-direction: column; gap: 0;
    margin-top: 3rem;
  }

  .exp-item {
    padding: 2rem 0;
    border-bottom: 1px solid rgba(138,125,82,0.2);
    display: flex; gap: 1.5rem;
    align-items: flex-start;
    cursor: default;
    transition: background 0.3s;
  }

  .exp-item:first-child { border-top: 1px solid rgba(138,125,82,0.2); }

  .exp-num {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 1.2rem;
    color: var(--khaki-light);
    opacity: 0.5;
    min-width: 40px;
    padding-top: 2px;
  }

  .exp-body h3 {
    font-family: 'Cinzel', serif;
    font-size: 1rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    margin-bottom: 0.5rem;
    color: var(--white);
  }

  .exp-body p {
    font-size: 0.95rem;
    font-weight: 300;
    line-height: 1.7;
    opacity: 0.6;
  }

  .exp-visual {
    position: relative;
  }

  .exp-main-img {
    width: 100%;
    height: 550px;
    object-fit: cover;
    filter: saturate(0.85) brightness(0.9);
    border: 1px solid var(--khaki);
  }

  .exp-tag-overlay {
    position: absolute;
    top: 2rem; left: -2rem;
    background: var(--green);
    border: 1px solid var(--khaki);
    padding: 1.2rem 1.5rem;
  }

  .exp-tag-overlay span {
    display: block;
    font-family: 'Bebas Neue', sans-serif;
    font-size: 2rem;
    color: var(--khaki-light);
    line-height: 1;
  }

  .exp-tag-overlay small {
    font-size: 0.6rem;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    opacity: 0.6;
  }

  /* TESTIMONIALS */
  #depoimentos {
    background: linear-gradient(180deg, var(--black) 0%, #060a04 100%);
    text-align: center;
  }

  .testimonials-title-wrap { margin-bottom: 4rem; }

  .testimonials-wrapper {
    overflow: hidden;
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    padding-bottom: 2rem;
  }

  .testimonials-track {
    display: flex;
    gap: 1.5rem;
    width: max-content;
    animation: marquee 30s linear infinite;
  }

  .testimonials-track:hover {
    animation-play-state: paused;
  }

  @keyframes marquee {
    0% { transform: translateX(0); }
    100% { transform: translateX(calc(-50% - 0.75rem)); }
  }

  .testimonial-card {
    width: 380px;
    background: rgba(45,74,30,0.15);
    border: 1px solid rgba(138,125,82,0.2);
    padding: 2.5rem;
    text-align: left;
    position: relative;
    transition: border-color 0.3s, background 0.3s;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .testimonial-card:hover {
    border-color: var(--khaki);
    background: rgba(45,74,30,0.25);
  }

  .testimonial-quote {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 5rem;
    color: var(--khaki-light);
    opacity: 0.3;
    line-height: 0.7;
    margin-bottom: 1rem;
    display: block;
  }

  .testimonial-text {
    font-size: 1rem;
    font-weight: 300;
    font-style: italic;
    line-height: 1.8;
    opacity: 0.75;
    margin-bottom: 1.5rem;
  }

  .testimonial-author {
    display: flex; align-items: center; gap: 1rem;
  }

  .author-avatar {
    width: 44px; height: 44px;
    border-radius: 50%;
    background: var(--camo-1);
    border: 2px solid var(--khaki);
    display: flex; align-items: center; justify-content: center;
    font-family: 'Bebas Neue', sans-serif;
    font-size: 1.2rem;
    color: var(--khaki-light);
    overflow: hidden;
  }

  .avatar-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .author-name {
    font-family: 'Cinzel', serif;
    font-size: 0.85rem;
    font-weight: 700;
    color: var(--white);
  }

  .author-trail {
    font-size: 0.7rem;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    opacity: 0.5;
    margin-top: 0.1rem;
  }

  /* CTA / CONTACT */
  #contato {
    position: relative;
    overflow: hidden;
    padding: 0;
  }

  .cta-bg {
    position: absolute; inset: 0;
    background-image: url('https://www.melhoresdestinos.com.br/wp-content/uploads/2019/10/chapada-diamantina.jpg');
    background-size: cover;
    background-position: center 60%;
    filter: brightness(0.2) saturate(0.5);
  }

  .cta-overlay {
    position: absolute; inset: 0;
    background: linear-gradient(135deg, rgba(10,30,5,0.85) 0%, rgba(0,0,0,0.7) 100%);
  }

  .cta-content {
    position: relative; z-index: 2;
    text-align: center;
    padding: 8rem 4rem;
  }

  .cta-title {
    font-family: 'Bebas Neue', sans-serif;
    font-size: clamp(2.5rem, 6vw, 5rem);
    letter-spacing: 0.05em;
    color: var(--white);
    line-height: 0.95;
    margin: 1.5rem 0 0.5rem;
  }

  .cta-title em {
    color: var(--khaki-light);
    font-style: normal;
  }

  .cta-sub {
    font-size: 1.1rem;
    font-weight: 300;
    opacity: 0.65;
    margin-bottom: 3rem;
    letter-spacing: 0.1em;
  }

  .cta-btn-wrapper {
    display: flex;
    justify-content: center;
    margin: 0 auto 2rem;
  }

  .cta-whatsapp-btn {
    background: var(--green);
    border: 1px solid var(--khaki);
    color: var(--white);
    font-family: 'Barlow Condensed', sans-serif;
    font-weight: 600;
    font-size: 0.8rem;
    letter-spacing: 0.25em;
    text-transform: uppercase;
    text-decoration: none;
    padding: 1rem 2rem;
    cursor: pointer;
    transition: background 0.3s;
    white-space: nowrap;
  }

  .cta-whatsapp-btn:hover {
    background: var(--khaki);
  }

  .cta-contacts {
    display: flex; justify-content: center; gap: 3rem;
    margin-top: 2rem;
  }

  .contact-link {
    text-decoration: none;
    color: var(--khaki-light);
    transition: color 0.3s;
  }
  
  .contact-link:hover {
    color: var(--green);
  }

  .cta-contact-item {
    display: flex; flex-direction: column; align-items: center; gap: 0.3rem;
  }

  .cta-contact-item .label {
    font-size: 0.65rem;
    letter-spacing: 0.3em;
    text-transform: uppercase;
    opacity: 0.4;
  }

  .cta-contact-item .value {
    font-family: 'Cinzel', serif;
    font-size: 0.9rem;
    color: var(--khaki-light);
  }

  /* FOOTER */
  footer {
    background: #050505;
    border-top: 1px solid rgba(138,125,82,0.2);
    padding: 3rem 4rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .footer-logo {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 1.5rem;
    letter-spacing: 0.15em;
    color: var(--white);
    opacity: 0.5;
  }
  .footer-logo span { color: var(--khaki); }

  .footer-copy {
    font-size: 0.7rem;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    opacity: 0.5;
    text-align: center;
    line-height: 1.6;
  }

  .footer-copy a {
    color: var(--khaki-light);
    text-decoration: none;
    transition: color 0.3s;
  }

  .footer-copy a:hover {
    color: var(--white);
  }

  .footer-social {
    display: flex; gap: 1.2rem;
  }

  .social-link {
    width: 38px; height: 38px;
    border: 1px solid rgba(138,125,82,0.3);
    display: flex; align-items: center; justify-content: center;
    color: var(--white);
    text-decoration: none;
    font-size: 1.1rem;
    opacity: 0.5;
    transition: opacity 0.2s, border-color 0.2s, background 0.2s;
    position: relative;
  }

  .social-link.tooltip::after {
    content: attr(data-tooltip);
    position: absolute;
    bottom: 120%;
    left: 50%;
    transform: translateX(-50%);
    background: var(--khaki);
    color: var(--black);
    padding: 0.4rem 0.8rem;
    font-size: 0.75rem;
    font-family: 'Barlow Condensed', sans-serif;
    letter-spacing: 0.1em;
    border-radius: 4px;
    white-space: nowrap;
    font-weight: 600;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s, bottom 0.3s;
    pointer-events: none;
  }

  .social-link.tooltip::before {
    content: '';
    position: absolute;
    bottom: calc(120% - 4px);
    left: 50%;
    transform: translateX(-50%);
    border-width: 4px 4px 0;
    border-style: solid;
    border-color: var(--khaki) transparent transparent transparent;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s, bottom 0.3s;
    pointer-events: none;
  }

  .social-link:hover.tooltip::after,
  .social-link:hover.tooltip::before {
    opacity: 1;
    visibility: visible;
    bottom: 135%;
  }

  .social-link:hover.tooltip::before {
    bottom: calc(135% - 4px);
  }

  .social-link:hover {
    opacity: 1;
    border-color: var(--khaki-light);
    background: rgba(138,125,82,0.1);
  }

  /* ANIMATIONS */
  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(30px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  .reveal {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.8s ease, transform 0.8s ease;
  }

  .reveal.visible {
    opacity: 1;
    transform: translateY(0);
  }

  /* WOLF PAW CURSOR */
  .paw-trail {
    position: fixed;
    pointer-events: none;
    z-index: 9999;
    font-size: 22px;
    color: var(--khaki-light);
    opacity: 0;
    animation: pawFade 1s ease forwards;
    user-select: none;
  }

  @keyframes pawFade {
    0%   { opacity: 0.6; transform: scale(0.5) rotate(-20deg); }
    100% { opacity: 0; transform: scale(1) rotate(0deg) translateY(10px); }
  }

  /* MOBILE */
  @media (max-width: 900px) {
    nav { padding: 1rem 1.5rem; }
    nav ul { gap: 1rem; }
    
    .nav-desktop-only { display: none !important; }

    .hero-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      padding: 0 1.5rem;
    }

    .hero-actions { display: flex; width: 100%; gap: 0.8rem; }
    .hero-actions .btn-primary, 
    .hero-actions .btn-secondary {
      flex: 1;
      padding: 1rem 0.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }

    section { padding: 4rem 1.5rem; }
    .about-grid, .experience-grid { grid-template-columns: 1fr; gap: 2rem; }
    .trails-grid { grid-template-columns: 1fr 1fr; }
    .testimonials-wrapper { padding-bottom: 1.5rem; }
    .testimonial-card { width: 300px; }
    .stats-band { flex-wrap: wrap; padding: 1rem; }
    .stat-item { border-right: none; border-bottom: 1px solid rgba(138,125,82,0.3); flex: 1 1 40%; }
    footer { flex-direction: column; gap: 1.5rem; text-align: center; }
    .about-visual { height: 350px; }
    .about-img-main { height: 300px; }
    .exp-tag-overlay { left: 0.5rem; }
    .cta-whatsapp-btn { width: 100%; text-align: center; box-sizing: border-box; }
    .cta-contacts { flex-direction: column; gap: 1rem; }
  }
</style>








